<template>
  <div
    class="app-content-title"
    :class="{ 'app-content-title--margin': title }"
  >
    <div v-if="linkTo" class="app-content-title__link-container">
      <app-link :to="linkTo" back :label="linkText" />
    </div>

    <div class="app-content-title__bottom" v-if="title">
      <slot name="title">
        <component :is="tag" class="app-content-title__title" v-text="title" />
      </slot>

      <!-- <div class="app-content-title__title-helper">
        <slot name="append" />
      </div> -->
    </div>
  </div>
</template>

<script>
import AppLink from '@/components/ui/AppLink.vue';

export default {
  name: 'AppContentTitle',
  components: {
    AppLink,
  },
  props: {
    tag: {
      type: String,
      default: 'h1',
    },
    linkTo: [String, Object],
    linkText: String,
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.app-content-title {
  $root: &;
  // margin: 0 0 20px;
  margin: 0 0 30px;

  @include media-xxs() {
    margin-bottom: 15px;
  }

  &__link-container {
    width: 100%;
  }

  &__bottom {
    display: flex;
    align-items: center;
  }

  &__title {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 1.3125rem;
    // margin-right: 40px;
    font-weight: 500;

    @include media-xxs() {
      margin-right: 0;
      font-size: rem(13);
    }
  }

  // &__title-helper {
  //   width: 100%;
  // }

  &--margin {
    #{$root}__link-container,
    #{$root}__bottom {
      margin: 0 0 15px;
    }
  }
}
</style>
